import React from 'react'
import classes from './Container.module.css'

export default props => (
  <div className={classes.Container} style={{ maxWidth: props.width }}>
    {props.children}
  </div>
)
